PJQ.models.invoices = {};

// Settings
PJQ.models.invoices.InvoiceUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [];
        if (this.options.forCompany) {
            params.push({
                parameter: 'forCompany',
                value: true
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'invoices'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ], params);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.invoices.InvoiceSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'invoices'
            },
            {
                endpoint: 'settings'
            }
        ], params);
    }
});

PJQ.models.invoices.InvoiceIntegrationSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'invoices'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'integration'
            }
        ], [
            {
                parameter: 'invoiceId',
                value: this.options.invoiceId
            },
            {
                parameter: 'context',
                value: this.options.context
            }
        ]);
    },
    isCreditCard: function () {
        return _.contains(this.attributes.settings.paymentTypes, 'credit_card');
    },
    isACH: function () {
      return _.contains(this.attributes.settings.paymentTypes, 'ach');
    },
    getTerms: function() {
        return this.attributes.terms;
    }
});
// Invoices
PJQ.models.invoices.Invoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'invoiceId',
    endpoint: function () {
        let params = [];
        if (this.get('context'))
            params.push({
               parameter: 'context',
               value: this.get('context')
            });
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'invoices',
                value: this.get('invoiceId')
            }
        ], params);
    },
    getInvoiceStatusLabel: function(includeDate = true) {
        let result = PJQ.constants.invoices.invoiceStatusNames[this.get('invoiceStatusId')];

        if (includeDate) {
            if (this.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.PAYMENT_REQUESTED)
                result += ' - ' + PJQ.helpers.dateHelpers.getDateString(new Date(this.get('requestedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
            else if (this.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.PAID)
                result += ' - ' + PJQ.helpers.dateHelpers.getDateString(new Date(this.get('paidOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
            else if (this.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.VOIDED)
                result += ' - ' + PJQ.helpers.dateHelpers.getDateString(new Date(this.get('voidedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
            else if (this.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.REFUNDED)
                result += ' - ' + PJQ.helpers.dateHelpers.getDateString(new Date(this.get('refundedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
        }

        return result;
    }
});

PJQ.collections.invoices = {};
PJQ.collections.invoices.Invoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoices.Invoice,
    endpoint: function (urlOptions) {
        let endpointArr = [
            {
                endpoint: 'invoices'
            }
        ];

        if (urlOptions && urlOptions.isExport)
            endpointArr.push({endpoint: 'export'});

        return PJQ.helpers.urlHelpers.generateEndpoint(endpointArr);
    },
    parse: function (data) {
        if (this.options.isExport) {
            this.exportURL = data.url;
        }
        else {
            this.totalRows = 0;
            this.totalDraft = 0;
            this.totalRequested = 0;
            this.totalPaymentPending = 0;
            this.totalPaid = 0;
            this.totalVoided = 0;
            this.totalRefunded = 0;
            this.totalReturned = 0;
            if (data) {
                this.totalRows = data.totals.totalRows;
                this.totalDraft = data.totals.totalDraft;
                this.totalRequested = data.totals.totalRequested;
                this.totalPaymentPending = data.totals.totalPaymentPending;
                this.totalPaid = data.totals.totalPaid;
                this.totalVoided = data.totals.totalVoided;
                this.totalRefunded = data.totals.totalRefunded;
                this.totalReturned = data.totals.totalReturned;
                return data.rows;
            }
        }
        return null;
    },
    export: function (data, callback) {
        if (typeof callback !== 'function') {
            return;
        }
        new PJQ.ajax.Request({
            endpoint: this.endpoint({
                isExport: true
            }),
            type: 'POST',
            timeout: 600000,
            data: data
        }).post().done(function (response) {
            callback(response);
        }).fail(function () {
            callback(null);
        });
    }
});

PJQ.collections.invoices.Transactions = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function (urlOptions) {
        let endpointArr = [
            {
                endpoint: 'invoices',
                value: this.options.invoiceId
            },
            {
                endpoint: 'transactions'
            }
        ];

        if (urlOptions && urlOptions.isExport)
            endpointArr.push({endpoint: 'export'});

        return PJQ.helpers.urlHelpers.generateEndpoint(endpointArr);
    },
    parse: function (data) {
        if (this.options.isExport) {
            this.exportURL = data.url;
        }
        else {
            this.totalRows = 0;
            this.totalPaid = 0;
            this.totalVoided = 0;
            this.totalRefunded = 0;
            if (data && data.invoiceId === undefined) {
                this.totalRows = data.totals.totalRows;
                this.totalPaid = data.totals.totalPaid;
                this.totalVoided = data.totals.totalVoided;
                this.totalRefunded = data.totals.totalRefunded;
                return data.rows;
            }
        }
        return null;
    },
    export: function (data, callback) {
        if (typeof callback !== 'function') {
            return;
        }
        new PJQ.ajax.Request({
            endpoint: this.endpoint({
                isExport: true
            }),
            type: 'POST',
            timeout: 600000,
            data: data
        }).post().done(function (response) {
            callback(response);
        }).fail(function () {
            callback(null);
        });
    }
});

PJQ.collections.invoices.Notifications = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function (urlOptions) {
        let endpointArr = [
            {
                endpoint: 'invoices',
                value: this.options.invoiceId
            },
            {
                endpoint: 'notifications'
            }
        ];

        return PJQ.helpers.urlHelpers.generateEndpoint(endpointArr);
    }
});
